import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export enum DialogOpenType {
    Introduction = "Introduction",
    ExportRoom = "exportRoom",
    ResetRoom = "resetRoom",
    SaveRoom = "saveRoom",
    LoadSetup = "loadSetup",
    NewSetup = "newSetup",
    Null = "null",
    Logout = "logout",
    ReportIssue = "reportIssue",
    ChangePatient = "changePatient",
    SaveSceneJson = "saveSceneJson",
    Import = "import",
}

export type DialogSliceType = {
    isDialogOpen: boolean;
    type: DialogOpenType;
};

const initialState = {
    isDialogOpen: false,
    type: DialogOpenType.SaveRoom,
} as DialogSliceType;

const DialogSlice = createSlice({
    name: "dialog",
    initialState: initialState,
    reducers: {
        openDialog: (state, action: PayloadAction<DialogSliceType>) => {
            state.isDialogOpen = action.payload.isDialogOpen;
            state.type = action.payload.type;
        },
    },
});

export const { openDialog } = DialogSlice.actions;

export default DialogSlice.reducer;
